module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    staticClass: "view"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "online-container",
    on: {
      "mouseover": function($event) {
        _vm.serviceShow = true
      },
      "mouseleave": function($event) {
        _vm.serviceShow = false
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.serviceShow),
      expression: "serviceShow"
    }],
    staticClass: "online-service-content"
  }, [_c('ul', [_vm._m(1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.goConsult
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/img/index/icon_customerservice.svg"),
      "alt": "在线咨询"
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "online-service"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/img/index/icon_footer_help.svg"),
      "alt": "联系我们"
    }
  }), _vm._v(" "), _c('span', [_vm._v("联系我们")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('img', {
    attrs: {
      "src": require("./assets/img/index/icon_phone.svg"),
      "alt": "咨询电话"
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "service-title"
  }, [_vm._v("咨询电话")]), _vm._v(" "), _c('span', {
    staticClass: "service-phone"
  }, [_vm._v("400-116-0808")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "service-title"
  }, [_vm._v("在线咨询")]), _vm._v(" "), _c('span', [_vm._v("咨询享免费产品体验与专业讲解")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://wpa.qq.com/msgrd?v=3&uin=2186090024&site=qq&menu=yes"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/img/index/icon_qq.svg"),
      "alt": "在线QQ"
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "service-title"
  }, [_vm._v("在线咨询")]), _vm._v(" "), _c('span', [_vm._v("咨询享免费产品体验与专业讲解")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4e02ca4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 254
// module chunks = 12